import { useSelector } from 'react-redux';

export default function useUserInfo(){
  const user = useSelector(state=>state.auth?.user) || {};
  return user
  };